var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUpload(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 7,
    height: 15,
    viewBox: "0 0 7 15",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 3.13892C0 1.6897 1.17578 0.513916 2.625 0.513916C4.07422 0.513916 5.25 1.6897 5.25 3.13892V10.1389C5.25 11.1042 4.46523 11.8889 3.5 11.8889C2.53477 11.8889 1.75 11.1042 1.75 10.1389V4.45142C1.75 4.21079 1.94687 4.01392 2.1875 4.01392C2.42812 4.01392 2.625 4.21079 2.625 4.45142V10.1389C2.625 10.6229 3.01602 11.0139 3.5 11.0139C3.98398 11.0139 4.375 10.6229 4.375 10.1389V3.13892C4.375 2.17368 3.59023 1.38892 2.625 1.38892C1.65977 1.38892 0.875 2.17368 0.875 3.13892V11.0139C0.875 12.4631 2.05078 13.6389 3.5 13.6389C4.94922 13.6389 6.125 12.4631 6.125 11.0139V4.45142C6.125 4.21079 6.32188 4.01392 6.5625 4.01392C6.80312 4.01392 7 4.21079 7 4.45142V11.0139C7 12.9471 5.4332 14.5139 3.5 14.5139C1.5668 14.5139 0 12.9471 0 11.0139V3.13892Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUpload);
export default __webpack_public_path__ + "static/media/upload.a21014eb47b5931151a7bbbf2c62f74d.svg";
export { ForwardRef as ReactComponent };